export default __webpack_public_path__ + "static/media/img8.114f568c.jpg";